import React, { useCallback } from 'react';
import { LOGOUT } from 'utilities/routes';

import { createSearchParams, useNavigate } from 'react-router-dom';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg';

import { Locale } from '../../../app/my-account/interfaces/profile.interfaces';
import { useModalParams } from '../../modal/useModalManager';
import { PasswordChange } from '../../../app/my-account/pages/my-profile/components/patientComponents/PasswordChange';
import { useCustomToast } from 'layout/useToast';

interface AccountDropdownProps {
  isOpen: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  locale: Locale;
}

export const SuperAdminAccountDropdown: React.FC<AccountDropdownProps> = ({
  isOpen,
  locale,
}) => {
  const navigate = useNavigate();
  const { addToast } = useCustomToast();

  const { isOpen: isPasswordChangeModalOpen } =
    useModalParams('password-change');

  const handleUpdatePassword = useCallback(() => {
    addToast({
      type: 'positive',
      message: locale?.passwordChangeSuccess as unknown as string,
    });
  }, [addToast, locale?.passwordChangeSuccess]);

  if (isPasswordChangeModalOpen) {
    return <PasswordChange handleUpdatePassword={handleUpdatePassword} />;
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={`${
        !isOpen ? 'hidden' : 'flex'
      } w-[180px] flex-col gap-1.5 py-2.5 absolute top-full bg-white rounded-[20px] shadow-container z-20 right-0`}
    >
      <div
        className="px-5 py-2 text-semibold flex items-center gap-2.5 text-btn-black hover:bg-hover-blue rounded-[5px]"
        onClick={() =>
          navigate({
            search: createSearchParams({
              'password-change': 'true',
            }).toString(),
          })
        }
      >
        {locale?.superAdminAccountOptions?.changePassword as unknown as string}
      </div>

      <hr className="my-[5px]" />

      {/*<div*/}
      {/*  className="px-5 hidden py-2 text-semibold items-center gap-2.5 text-btn-black hover:bg-hover-blue rounded-[5px]"*/}
      {/*  onClick={() => setIsOpenVeradigm(true)}*/}
      {/*>*/}
      {/*  {loading ? <Spinner className="mx-auto" /> : 'Manage ePrescribe'}*/}
      {/*</div>*/}

      <div
        className="px-5 py-2 text-semibold flex items-center gap-2.5 text-btn-black hover:bg-hover-blue rounded-[5px]"
        onClick={() => navigate(LOGOUT)}
      >
        <LogoutIcon />
        {locale?.superAdminAccountOptions?.logOut as unknown as string}
      </div>
    </div>
  );
};
